import { Component } from '@angular/core';

@Component({
  selector: 'phc-contributing-image-component',
  templateUrl: './contributing.component.html',
  styleUrls: ['./contributing.component.scss']
})
export class ContributingComponent  {


}
